import { render, staticRenderFns } from "./PageDetails.vue?vue&type=template&id=75140c5d&scoped=true&"
import script from "./PageDetails.vue?vue&type=script&lang=js&"
export * from "./PageDetails.vue?vue&type=script&lang=js&"
import style0 from "./PageDetails.vue?vue&type=style&index=0&id=75140c5d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75140c5d",
  null
  
)

export default component.exports